// extracted by mini-css-extract-plugin
export default {"listItem":"ListItem2_listItem__1h4G9"};